var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"text-center":"","w-100":"","pb-5":""}},[_c('div',{attrs:{"upper-case":"","mjf-green":"","fs-20":"","bold":""}},[_vm._v("complete your upgrade request")]),_c('div',{attrs:{"bold":"","pt-2":""}},[_vm._v("Please log in below")])])
}]

export { render, staticRenderFns }